import moment from 'moment';
import React, { useEffect, useState } from 'react';
import { CircularProgressbar } from 'react-circular-progressbar';
import SendToMobileIcon from "@mui/icons-material/SendToMobile";
import IconButton from "@mui/material/IconButton";
import Tooltip from "@mui/material/Tooltip";
// import NotificationsIcon from "@mui/icons-material/Notifications";
import { makePostRequest } from "../../../utils/utils";
import swal from "sweetalert";

function ProgressBar(prop) {

  let timer = null;
  // let totalmin = 0;
  // let temp = 0;

  const [getTotaltime, setTotaltime] = useState(0);
  // const [getStaytime, setStaytime] = useState(0);
  const [getcolor, setcolor] = useState('');
  const [getbackgroundColor, setbackgroundColor] = useState('');
  const [getTextColor, setTextColor] = useState('');
  const [getCheck, setCheck] = useState(Boolean);
  const [extendStay, setExtendStay] = useState(Boolean);
  const [, setintohrs] = useState(0);


  // function toHoursAndMinutes(totalMinutes) {

  //   const hours = Math.floor(totalMinutes / 60).toLocaleString('en-US', {
  //     minimumIntegerDigits: 2,
  //     useGrouping: false
  //   });

  //   const minutes = (totalMinutes % 60).toLocaleString('en-US', {
  //     minimumIntegerDigits: 2,
  //     useGrouping: false
  //   });

  //   var str = hours + ':' + minutes;
  //   return str;
  // }

  const convertMinutes = (totMinutes) => {
    console.log("Total Minutes " + parseInt(totMinutes));
    const totalMinutes = parseInt(totMinutes);
    const minutesInDay = 24 * 60;
    console.log(minutesInDay)
    const minutesInHour = 60;
    console.log(minutesInHour)
    var days = Math.floor(totalMinutes / minutesInDay);
    console.log(days);
    var remainingMinutes = totalMinutes % minutesInDay;
    var hours = Math.floor(remainingMinutes / minutesInHour);
    var minutes = remainingMinutes % minutesInHour;
    console.log("Days " + days + " hours " + hours + " minutes " + minutes)
    return `${days}d:${hours}h:${minutes}`;
  }

  function addMinutes(timeString, addMinutes) {

    if (timeString != null && addMinutes != null) {

      var timeSplit = timeString.split(':');
      var hours = parseInt(timeSplit[0]);
      var minutes = parseInt(timeSplit[1]) + parseInt(addMinutes);
      hours += Math.floor(minutes / 60);
      while (hours >= 24) {
        hours -= 24;
      }
      minutes = minutes % 60;
      return ('0' + hours).slice(-2) + ':' + ('0' + minutes).slice(-2);
    }
    else
      return '';
  }

  const handleExtendStay = (e, fcm_token, id, fname, lname,profile_pic,guest_type) => {
    console.log("Event value "+profile_pic);
    var jsonObj = { id: id.toString(), fname: fname, lname: lname,picture:profile_pic,guest_type:guest_type };
    
    let bodyFormData = {
      title: "Need to Extend Stay!!",
      message: "Need to Extend Stay!!",
      firebaseToken: fcm_token,
      extraData: jsonObj
    };

    makePostRequest("guards/sendNotification", bodyFormData)
      .then((response) => {
      //   setState({ openTost: true });
      // enqueueSnackbar(notification.body);
      // setShow(true);

      setExtendStay(false);
      swal("Success", "Request For Extend Stay Sent", "success", {
        timer: 1000,
        buttons: false,
      });
      
      })
      .catch((err) => {
        swal(
          "There was an error in sending Notification!!",
          "more error details",
          "warning"
        );
      });
  };


  useEffect(() => {
    let temp = 0;
    temp += 1;
    if (prop.flag == 'pending') {

      console.log('******** 1 In a pending Block*********')
      // const time = prop.entryTime;

      // console.log('TIme ' + time)
      var startDate = moment(prop.entryTime).utc().format("YYYY-MM-DD HH:mm:ss")
      // new Date(time);
      console.log('startTime ' + startDate)

      let currentDate =moment().format("YYYY-MM-DD HH:mm:ss");
      let difference = moment(currentDate).diff(startDate, 'minutes')
      // Math.abs(currentDate - startDate)
      console.log("Difference " + difference);

      // var minutes = Math.floor(difference / 60000);
      // var seconds = ((difference % 60000) / 1000).toFixed(0);

      // totalmin = minutes + ":" + (seconds < 10 ? '0' : '') + seconds;

      setintohrs(difference);
      setTotaltime(difference);
      setcolor('#F03939');  //red color
      setbackgroundColor('#ffe5e5');
      setTextColor('#F03939')

    }
    else if (prop.flag == 'active'){
      console.log('********  In a Active *********')


        console.log('********  Visitor have No Exit time*********')
        const time = prop.hrs
        let praposedExit = moment(prop.entryTime).add(time, 'minute').utc().format("YYYY-MM-DD HH:mm:ss");
        console.log(praposedExit)
        let currentTime = moment().format("YYYY-MM-DD HH:mm:ss");
        console.log("Current time "+currentTime);
        // let diff = Math.abs(currentTime - entryTime)

        if (praposedExit > currentTime) {
          console.log('******** Difference is less than total stay *********')
        var minutes = moment(praposedExit).diff(currentTime, 'minutes');

          setCheck(false);
          setcolor('#08AE36');    //green color
          setbackgroundColor('#effff3');
          setTextColor('#08AE36')
          setTotaltime(minutes);


        }
        else {
          console.log('******** Difference is greater than total stay *********')

          var minutes = moment(currentTime).diff(praposedExit, 'minutes');

          setExtendStay(true);
          console.log("extendStay "+extendStay);
          setCheck(true);
          setcolor('#F03939');  //red color
          setbackgroundColor('#ffe5e5');
          setTextColor('#F03939')
          setTotaltime(minutes);

        }    
      }

    // }

    timer = setInterval(() => {
      if (prop.flag == 'pending') {

        console.log('******** 1 In a pending Block*********')
        // const time = prop.entryTime;
  
        // console.log('TIme ' + time)
        var startDate = moment(prop.entryTime).utc().format("YYYY-MM-DD HH:mm:ss")
        // new Date(time);
        console.log('startTime ' + startDate)
  
        let currentDate =moment().format("YYYY-MM-DD HH:mm:ss");
        let difference = moment(currentDate).diff(startDate, 'minutes')
        // Math.abs(currentDate - startDate)
        console.log("Difference " + difference);
  
        // var minutes = Math.floor(difference / 60000);
        // var seconds = ((difference % 60000) / 1000).toFixed(0);
  
        // totalmin = minutes + ":" + (seconds < 10 ? '0' : '') + seconds;
  
        setintohrs(difference);
        setTotaltime(difference);
        setcolor('#F03939');  //red color
        setbackgroundColor('#ffe5e5');
        setTextColor('#F03939')
  
      }
      else if (prop.flag == 'active'){
        console.log('********  In a Active *********')
  
  
          console.log('********  Visitor have No Exit time*********')
          const time = prop.hrs
          let praposedExit = moment(prop.entryTime).add(time, 'minute').utc().format("YYYY-MM-DD HH:mm:ss");
          console.log(praposedExit)
          let currentTime = moment().format("YYYY-MM-DD HH:mm:ss");
          console.log("Current time "+currentTime);
          // let diff = Math.abs(currentTime - entryTime)
  
          if (praposedExit > currentTime) {
            console.log('******** Difference is less than total stay *********')
          var minutes = moment(praposedExit).diff(currentTime, 'minutes');
  
            setCheck(false);
            setcolor('#08AE36');    //green color
            setbackgroundColor('#effff3');
            setTextColor('#08AE36')
            setTotaltime(minutes);
  
  
          }
          else {
            console.log('******** Difference is greater than total stay *********')
  
            var minutes = moment(currentTime).diff(praposedExit, 'minutes');
  
            setExtendStay(true);
            console.log("extendStay "+extendStay);
            setCheck(true);
            setcolor('#F03939');  //red color
            setbackgroundColor('#ffe5e5');
            setTextColor('#F03939')
            setTotaltime(minutes);
  
          }    
        }
    }, 1000 * 60);
    return () => clearInterval(timer);
  }, [timer]);

  return (
    <>
   
    {extendStay?<div className="visitorNotiMain">
                              <Tooltip title="Need to Extend Stay">
                                <IconButton>
                                  <SendToMobileIcon
                                    onClick={(event) =>
                                      handleExtendStay(
                                        event,
                                        prop.fcm_token,
                                        prop.id,
                                        prop.fname,
                                        prop.lname,
                                        prop.profile_pic,
                                        prop.guest_type
                                      )
                                    }
                                  />
                                </IconButton>
                              </Tooltip>
                            </div>:
                            <div></div>}
        {prop.flag == 'pending' ?
          <CircularProgressbar
            background
            value={getTotaltime}
            radius={40}
            maxValue={getTotaltime}
            styles={{
              path: {
                // Trail color
                stroke: getcolor,
                strokeWidth:3,
              },
              background: {
                fill: getbackgroundColor,
              },
              text: {
                // Text color
                fill: getTextColor
              },
            }}
            text={convertMinutes(getTotaltime)}
          /> :
          <>
          {getCheck?<CircularProgressbar
                  background
                  value={getTotaltime}
                  radius={40}
                  maxValue={getTotaltime}
                  styles={{path: {
                      // Trail color
                      stroke: getcolor,
                      strokeWidth:3,
                    },background: {
                      fill: getbackgroundColor,
                    },
                    text: {
                      // Text color
                      fill: getTextColor},}}
                  text={convertMinutes(getTotaltime)}
              /> : <CircularProgressbar
                  background
                  value={getTotaltime}
                  radius={40}
                  maxValue={prop.hrs}
                  styles={{path: {
                      // Trail color
                      stroke: getcolor,
                      strokeWidth:3,                      
                    },background: {
                      fill: getbackgroundColor,
                    },text: {
                      // Text color
                      fill: 'getTextColor'},
                  }}                       
                     text={convertMinutes(getTotaltime)}
              />
              }
          </>
          }
        </>
      //  }
   
      // </>
      
  );
}

export default ProgressBar;